import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icon-exchange-success.png'


const _withScopeId = n => (_pushScopeId("data-v-08298526"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "exchange" }
const _hoisted_2 = { class: "exchange-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "兑换成功！", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "tips：如需修改地址，请联系在线客服", -1))

import { ref, onActivated } from 'vue';
    import Navigate from "@/components/Navigate";
    import { useRouter } from "vue-router";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangeSuccess',
  setup(__props) {

    const $router = useRouter();
    const anotherCount = ref(0);
    const showBottom = ref(false);
    const price = ref(0);
    const hrefLink = ref('');
    const productName = ref('');

    onActivated(() => {
        hrefLink.value = window.localStorage.getItem('hrefLink') as string
        if($router.currentRoute.value.query?.price) {
            const product = JSON.parse(window.localStorage.getItem('exchangeDetails') as string);
            productName.value = product.productName;
            price.value = Number($router.currentRoute.value.query.price)
        }else {
            price.value = 0;
        }
    })

    const goBack = () => {
        $router.go(-3)
    }
   


return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(productName.value) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(price.value), 1),
        _createTextVNode(" 积分")
      ]),
      _hoisted_5,
      _createVNode(_component_router_link, { to: "/orderList/?isFormExchange=1" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_button, {
            round: "",
            class: "button-default"
          }, {
            default: _withCtx(() => [
              _createTextVNode("查看积分订单")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_button, {
        round: "",
        class: "button-primary",
        type: "primary",
        onClick: goBack,
        color: "#FF3469"
      }, {
        default: _withCtx(() => [
          _createTextVNode("继续兑换")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})